import {useSelector} from 'react-redux';
import {ParkingTypes} from 'common/marketing-metas';

const useTitle = (fallbackTitle, marketingMetasType) => {
    const {
        meta_title: metaTitle,
        'meta-title': metaTitleLegal,
        meta_title_marketing: metaTitleMarketing,
        meta_title_transient: metaTitleTransient,
        optional_meta_title_transient: optionalMetaTitleTransient,
        meta_title_monthly: metaTitleMonthly,
        optional_meta_title_monthly: optionalMetaTitleMonthly,
    } = useSelector(state => state.page);

    let title = '';

    if (marketingMetasType === ParkingTypes.Transient) {
        title = optionalMetaTitleTransient || metaTitleTransient;
    } else if (marketingMetasType === ParkingTypes.Monthly) {
        title = optionalMetaTitleMonthly || metaTitleMonthly;
    }

    return (
        title ||
        metaTitle ||
        metaTitleLegal ||
        metaTitleMarketing ||
        fallbackTitle ||
        'SpotHero | Get Everywhere Easier | Reserve Parking and Save'
    );
};

export default useTitle;
